export const notSelectableResourceTypes = new Set([
  "rds_snapshot_source",
  "dynamo_db_backup_source",
]);

export const notActionableResourceTypes = new Set([
  "rds_snapshot_source",
  "dynamo_db_backup_source",
]);
